import { FC } from 'react';

import DirectDebitAdd from 'components/direct-debit-add';

const DirectDebitMethod: FC = (): JSX.Element => <DirectDebitAdd />;

export default DirectDebitMethod;
